import React, { useEffect, useState } from "react";
import "./FilterModel.css";
import {
    FaHotel, FaGlassCheers, FaUmbrellaBeach, FaChalkboardTeacher, FaStar,
} from "react-icons/fa";
import { MdOutlineBedroomParent } from "react-icons/md";
import Slider from '@mui/material/Slider';
import axios from "axios";
import { API_BASE_URL } from "../utils";
import { sl } from "date-fns/locale";





export default function FilterModal({ isOpen, onClose, setFiltersAndSort, fetchDataWithFilters }) {
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(1000);
    const [min2, setMin2] = useState(90);
    const [max2, setMax2] = useState(500);

    const [value, setValue] = useState([min, max]);
    const [value2, setValue2] = useState([min2, max2]);

    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [selectedVenues, setSelectedVenues] = useState([]);
    const [selectedPackages, setSelectedPackages] = useState([]);
    const [area, setArea] = useState([]);

    const [venueData, setVenueData] = useState([]);
    const [packageData, setPackageData] = useState([]);
    const [city, setCity] = useState([]);


    useEffect(() => {
        setFiltersAndSort({
            city: selectedCities,
            area: selectedAreas,
            venue: selectedVenues,
            package: selectedPackages,
            distance: value,
            price: value2,
        });
    }, [selectedCities, selectedAreas, selectedVenues, selectedPackages, value, value2, setFiltersAndSort]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePrice = (event, newValue) => {
        setValue2(newValue);
    };

    const marks = [
        { value: min, label: `${min} km` },
        { value: max, label: `${max} km` },
    ];

    const marks2 = [
        { value: min2, label: `₹${min2}` },
        { value: max2, label: `₹${max2}` },
    ];




    const [packageId, setPackageId] = useState("1");


    const url = `${API_BASE_URL}/master/assets/uploads/`;

    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/master/APIs/ClubPackage/getVenuType`)
            .then((response) => {
                setVenueData(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .get("https://partywitty.com/master/APIs/Common/getAllPackageTitle")
            .then((response) => {
                setPackageData(response.data.data)
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        axios
            .get("https://partywitty.com/master/Api/getData/getAreaLead")
            .then((response) => {
                setCity(response.data.data)
            })
            .catch((error) => console.log(error));
    }, []);


    const handleSelectVenue = (venueId) => {
        setSelectedVenues((prev) => {
            const isSelected = prev.includes(venueId);
            const updated = isSelected
                ? prev.filter((id) => id !== venueId)
                : [...prev, venueId];
            return updated;
        });
    };

    const handleSelectPackage = (packageId) => {
        setSelectedPackages((prev) => {
            const isSelected = prev.includes(packageId);
            const updated = isSelected
                ? prev.filter((name) => name !== packageId)
                : [...prev, packageId];

            return updated;
        });
    };


    const handleCityChange = (cityId) => {
        setSelectedCities((prev) =>
            prev.includes(cityId)
                ? prev.filter((id) => id !== cityId)
                : [...prev, cityId]
        );
    };

    const handleAreaChange = (areaId) => {
        setSelectedAreas((prev) =>
            prev.includes(areaId)
                ? prev.filter((id) => id !== areaId)
                : [...prev, areaId]
        );
    };


    useEffect(() => {
        const fetchAreas = async () => {
            const apiUrl = "https://partywitty.com/master/Api/getDataPost/AreaLead";

            try {
                const areaResponses = await Promise.all(
                    selectedCities.map((cityId) => {
                        const formData = new FormData();
                        formData.append("city_id", cityId);
                        return axios.post(apiUrl, formData);
                    })
                );

                // Flatten and combine all area data
                const allAreas = areaResponses.flatMap((res) => res.data.data);
                const uniqueAreas = Array.from(
                    new Map(allAreas.map((a) => [a.id, a])).values()
                ); // Remove duplicates

                setArea(uniqueAreas);
            } catch (error) {
                console.error("Failed to fetch area data:", error);
            }
        };

        if (selectedCities.length > 0) {
            fetchAreas();
        } else {
            setArea([]);
        }
    }, [selectedCities]);



    if (!isOpen) return null;

    return (
        <div className="lpfm-modal-backdrop" onClick={onClose}>
            <div className="lpfm-filter-modal" onClick={(e) => e.stopPropagation()}>

                <div className="lpfm-filter-header">
                    <h3>Filter</h3>
                    <button className="lpfm-close-btn" onClick={onClose}>×</button>
                </div>
                <div className="lpfm-modal-content">
                    {/* Header */}

                    {/* Type of Venue */}
                    <div className="lpfm-filter-section">
                        <h4>Type of Venue</h4>
                        <div className="lpfm-filter-options-venue lpfm-venue-icons">
                            {venueData.map((item) => (
                                <div
                                    className={
                                        selectedVenues.includes(item.id)
                                            ? "f-m-type-of-venue-active"
                                            : "f-m-type-of-venue"
                                    }
                                    onClick={() => handleSelectVenue(item.id)}
                                    key={item.id}
                                >
                                    <img src={url + item.img} alt={item.name} />
                                    <div className="f-m-type-of-venue-overlay">
                                        <p>{item.name}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>

                    {/* Type of Packages */}
                    <div className="lpfm-filter-section">
                        <h4>Type of Packages</h4>
                        <div className="lpfm-filter-options-package lpfm-pills">
                            {packageData.map((item) => (
                                <div
                                    key={item.id}
                                    className={
                                        selectedPackages.includes(item.name)
                                            ? "f-m-type-of-package-active"
                                            : "f-m-type-of-package"
                                    }
                                    onClick={() => handleSelectPackage(item.name)}
                                >
                                    {item.name}
                                </div>
                            ))}
                        </div>

                    </div>

                    {/* Near By */}
                    <div className="lpfm-filter-section">
                        <h4>Near By</h4>
                        <div className="lpfm-range-bar">
                            <Slider
                                getAriaLabel={() => "distance range"}
                                value={value}
                                min={min}
                                max={max}
                                onChange={handleChange}
                                valueLabelDisplay="off"
                                marks={marks}
                            />
                            <p className="lpfm-price-range">
                                Distance Range: {value[0]}km - {value[1]}km
                            </p>
                        </div>
                    </div>

                    <div className="lpfm-filter-section">
                        <h4>Price</h4>
                        <div className="lpfm-range-bar">
                            <Slider
                                getAriaLabel={() => "Price range"}
                                value={value2}
                                min={min2}
                                max={max2}
                                onChange={handleChangePrice}
                                valueLabelDisplay="off"
                                marks={marks2}
                            />
                            <p className="lpfm-price-range">
                                Price Range: ₹{value2[0]} - ₹{value2[1]}
                            </p>
                        </div>
                    </div>


                    {/* Review Stars */}
                    <div className="lpfm-filter-section">
                        <h4>Review</h4>
                        <div className="lpfm-filter-options lpfm-stars">
                            {[5, 4, 3, 2, 1].map((val) => (
                                <button key={val}>{val} <FaStar /></button>
                            ))}
                        </div>
                    </div>

                    {/* Sitting */}
                    <div className="lpfm-filter-section">
                        <h4>Sitting</h4>
                        <div className="lpfm-filter-options lpfm-pills">
                            <button>Indoor</button>
                            <button>Outdoor</button>
                        </div>
                    </div>

                    {/* City & Area */}
                    <div className="lpfm-filter-section">
                        <h4>City & Area</h4>
                        <div className="lpfm-cities-areas-city">

                            <div className="lpfm-city-area">
                                <p>City</p>
                                {city.map((item) => (
                                    <label key={item.id}>
                                        <input
                                            type="checkbox"
                                            onChange={() => handleCityChange(item.id)}
                                            checked={selectedCities.includes(item.id)}
                                        />
                                        {item.name}
                                    </label>
                                ))}
                            </div>

                            <div className="lpfm-city-area">
                                <p>Area</p>
                                {area.length === 0 && <span className="lpfm-select-city-no-data">Select city first</span>}
                                {area.map((item) => (
                                    <label key={item.id}>
                                        <input type="checkbox"
                                            onChange={() => handleAreaChange(item.id)}
                                            checked={selectedAreas.includes(item.id)}
                                        />
                                        {item.name}
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>


                </div>
                <div className="lpfm-filter-footer">
                    <button className="lpfm-clear-btn">Clear Filter</button>
                    <button className="lpfm-result-btn" onClick={() => {
                        fetchDataWithFilters(); // ✅ triggered on click
                        onClose();              // ✅ close modal
                    }}>Show results</button>
                </div>
            </div>
        </div>
    );
}
